import { SWITCH_FUNCTION } from './index'
import { PaymentMethod, PaymentMethodLabel, PaymentTerm, PaymentTermLabel } from '../definition'

export const CONFIG_PREFFER_PAYMENTTERM = {
  [PaymentTerm.COD]: {
    show: false,
    label: PaymentTermLabel.COD
  },
  [PaymentTerm.CREDIT]: {
    show: true,
    label: PaymentTermLabel.CREDIT
  },
  [PaymentTerm.PPP]: {
    show: false,
    label: PaymentTermLabel.PPP
  },
  [PaymentTerm.FPP]: {
    show: true,
    label: PaymentTermLabel.FPP
  },
  [PaymentTerm.OTHER]: {
    show: false,
    label: PaymentTermLabel.OTHER
  }
}

export const CONFIG_BOOKING_PAYMENTTERM = {
  [PaymentTerm.COD]: {
    show: false,
    label: PaymentTermLabel.COD
  },
  [PaymentTerm.CREDIT]: {
    show: true,
    label: PaymentTermLabel.CREDIT
  },
  [PaymentTerm.PPP]: {
    show: true,
    label: PaymentTermLabel.PPP
  },
  [PaymentTerm.FPP]: {
    show: true,
    label: PaymentTermLabel.FPP
  },
  [PaymentTerm.OTHER]: {
    show: false,
    label: PaymentTermLabel.OTHER
  }
}

export const CONFIG_BOOKING_PAYMENTMETHOD = {
  [PaymentMethod.CASH]: {
    show: false,
    label: PaymentMethodLabel.CASH
  },
  [PaymentMethod.PAYNOW]: {
    show: true,
    label: PaymentMethodLabel.PAYNOW
  },
  [PaymentMethod.CARD]: {
    show: true,
    label: PaymentMethodLabel.CARD
  },
  [PaymentMethod.APPLE_PAY]: {
    show: false,
    label: PaymentMethodLabel.APPLE_PAY
  },
  [PaymentMethod.GOOGLE_PAY]: {
    show: false,
    label: PaymentMethodLabel.GOOGLE_PAY
  }
}

export const DEFAULT_PAYMENT_TERM = PaymentTerm.FPP

export const DEFAULT_BOOKING_PAYMENT_TERM = undefined

export const ONETIME_BOOKING_MANDATORY_FIELD = {
  customerName: true,
  contactNumber: true,
  contactNumberCode: SWITCH_FUNCTION.country_code,
  paymentTerm: true,
  email: !SWITCH_FUNCTION.tech_cus_required_only_contact,
  address1: true,
  address2: false,
  postalCode: false,
  city: false,
  country: false,
  service: true,
  residentialType: SWITCH_FUNCTION.residential_type,
  assignId: true,
  appoinmentDate: true,
  timeslot: true
}

export const CONTRACT_BOOKING_MANDATORY_FIELD = {
  customerName: true,
  contactNumber: true,
  contactNumberCode: SWITCH_FUNCTION.country_code,
  paymentTerm: true,
  email: !SWITCH_FUNCTION.tech_cus_required_only_contact,
  address1: true,
  address2: false,
  postalCode: false,
  city: false,
  country: false,
  service: true,
  residentialType: SWITCH_FUNCTION.residential_type
}

enum ContractDuration {
  Month = 'Month',
  Year = 'Year'
}

export const CONTRACT_DURATION: ContractDuration = ContractDuration.Year

export const CONTRACT_ONE_SERVICE = true

export const DURATION_1_YEAR = true

export const TASK_ASSIGN_MANDATORY = true

export const SERVICE_DURATION = [0.5, 1, 1.5, 2, 2.5, 3, 3.5, 4, 4.5, 5, 5.5, 6]
